<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0">
      <div class="col custom-form-main-label">
        {{ $store.translate('manage_sub_locations')}}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="createSubLocationForm">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('name')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="sublocname" type="text" id="txtlocname" v-bind:placeholder="$store.translate('location_name')" maxlength="200" name="sublocname" class="form-control" />
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12 text-right">
              <button @click="savelocation" type="submit" class="btn skin primary-button mt-1"><i class="icon-cog5 mr-2"></i> {{buttontext}}</button>
              <button v-if="locationId>0" @click="cancellocation" type="submit" class="btn skin primary-button mt-1"><i class="icon-cog5 mr-2"></i> {{$t('cancel')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row mt-3" v-if="sublocations.length>0">
      <div class="col-12">
        <table class="" style="width:100%">
          <tr>
            <td class="custom-form-label" style="padding-left: 0px !important; color: inherit">{{$store.translate('sublocations')}}</td>
            <td></td>
          </tr>
          <tr v-for="location in sublocations" class="mt-1">
            <td align="left" style="padding-left:0px !important;color:inherit">{{ location.locationname }}</td>
            <td align="right">
              <a @click="editSublocation(location.locationid,location.locationname)" style="color: inherit"><i style="font-size: 16px; color: inherit" class="fa fa-edit"></i></a>
              <a @click="deleteSublocation(location.locationid)" style="color: inherit"><i style="font-size: 16px; color: inherit" class="fa fa-trash-o"></i></a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

  var sublocations = [];
  var sublocname = '';
  var locationId = 0;
  var buttontext = '';
  export default {
    name: "manage-sub-location",
    components: {
    },
    props: {
      parentlocId: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        sublocations,
        sublocname: '',
        locationId: 0,
        buttontext,
      };
    },

    methods: {
      clearFields() {
        this.sublocname = '';
        this.buttontext = this.$t('add');
        this.locationId = 0;
      },
      getId() {
        return "child_" + this._uid;
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      async cancellocation() {
        this.buttontext = this.$t('add');
        this.locationId = 0;
        this.sublocname = '';
      },
      async savelocation() {
        if (!$('#createSubLocationForm').valid())
          return false;

        var request = {
          LocationId: this.locationId, LocationName: this.sublocname,
          ParentId: this.parentlocId,
        };

        try {
          var response = await this.$http.post(
            '/api/Locations/v1',
            request
          ).then(async response => {
            //this.clearFields();
            //vm.$root.$emit('refreshview');
            this.loadSubLocations();
            this.buttontext = this.$t('add');
          });

        } catch (err) {
          //alert(err);
          //handleClientException(err.response.status === 401);
        }
      },
      async editSublocation(id, name) {
        this.sublocname = name;
        this.locationId = id;
        this.buttontext = this.$t('save');
      },
      async deleteSublocation(id) {
        try {
          var msg = this.$t('confirm_delete')
          if (confirm(msg)) {
            this.$http.delete(`/api/Locations/v1/${id}`).then(async response => {
              this.loadSubLocations();
            });
          }
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadSubLocations() {
        try {
          this.clearFields();
          this.sublocations = [];
          if (this.parentlocId !== "undefined" && this.parentlocId != null && this.parentlocId > 0) {
            this.$http.get(`/api/Locations/v1/Sublocations/${this.parentlocId}`).then(async response => {
              this.sublocations = response.data;
              Vue.set(this, "sublocations", this.sublocations);
              this.$forceUpdate();
            });
          }

        } catch (err) {
          alert('some error:' + err)
        }
      },
    },
    computed: {

    },
    mounted() {
      _componentValidation('#createSubLocationForm');

      this.buttontext = this.$t('add');
    },
    watch: {
      parentlocId: function (newVal, oldVal) {
        this.clearFields();
        this.loadSubLocations();
      },
    }
  };

</script>





// WEBPACK FOOTER //
// src/components/location/manage-sub-location.vue